import CryptoJS from "crypto-js";

import type { IHlsData } from "./hls_models";

class HlsEncryption {
  s = [
    107, 82, 116, 85, 107, 72, 51, 116, 53, 95, 75, 122, 74, 76, 84, 104, 55, 114, 98, 50, 48, 95, 107, 100, 115, 76,
    108, 74, 115, 102, 115, 57, 52, 78, 104, 82, 111, 52, 108, 66, 80, 75, 81, 61,
  ];
  v = [
    57, 54, 53, 48, 48, 49, 54, 54, 100, 97, 53, 101, 98, 53, 57, 49, 97, 48, 52, 57, 55, 102, 57, 53, 51, 54, 54, 51,
    49, 101, 102, 50, 48, 51, 53, 53, 49, 50, 50, 56, 100, 57, 48, 101, 54, 53, 99, 52,
  ];
  iv = [56, 98, 121, 116, 101, 105, 118, 118];

  encKey(token: string): string {
    const s = String.fromCharCode(...this.s);

    const k = s.slice(0, 8) + token.split(".")[2].split("").reverse().join("").slice(0, 27) + s.slice(-9);

    return k.replace(/[+-]/g, "_").slice(0, 32);
  }

  decrypt(data: string, token: string): IHlsData {
    const key = CryptoJS.enc.Utf8.parse(this.encKey(token));

    const encryptedDataBytes = CryptoJS.enc.Base64.parse(data.trim());

    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: encryptedDataBytes,
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);

    return JSON.parse(decryptedStr);
  }

  encrypt(data: string): string {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify({ data }), String.fromCharCode(...this.v)).toString();

    return encrypted.toString();
  }
}

export default HlsEncryption;
